import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const DashboardRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to new platform
    navigate('/app/play', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0B0F14] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#C9A227] mx-auto mb-4" />
        <p className="text-foreground/60">Loading platform...</p>
      </div>
    </div>
  );
};

export default DashboardRedirect;
